import { generatePath } from 'react-router-dom'
import { SEO_RELEVANCE_PATH } from 'paths'
import { NavMenuItem } from '../NavMenuItem/NavMenuItem'
import { FileMultiple } from 'blaze-ui/icons'

interface Props {
  workspaceId: number
  onPress: () => void
}

const NavMenuSeoRelevanceItem = ({ workspaceId, onPress }: Props) => {
  return (
    <NavMenuItem
      icon={FileMultiple}
      activeIcon={FileMultiple}
      to={generatePath(SEO_RELEVANCE_PATH, { workspaceId })}
      onPress={onPress}
      label="SEO"
    />
  )
}

export { NavMenuSeoRelevanceItem }
